import clsx from "clsx";
import { ListPlaceholder } from "components/placeholders/ListItemPlaceholder";
import { PresetPromptDto } from "dtos/frankenstories/prompts/PresetPromptDto";
import { Dispatch, Fragment, SetStateAction } from "react";
import { Link } from "react-router-dom";
import { RouteLink } from "Routes";

export const PromptsDisplay = (props: {
    prompts?: Array<PresetPromptDto>;
    setActivePrompt: Dispatch<SetStateAction<PresetPromptDto | undefined>>;
    showLoading?: boolean;
    activePrompt?: PresetPromptDto;
}) => {
    const { prompts, setActivePrompt, showLoading, activePrompt } = props;

    return prompts == null ? (
        <Fragment>{showLoading && <ListPlaceholder />}</Fragment>
    ) : prompts.length === 0 ? (
        <div className="vstack gap-2">
            <div className="alert bg-dark vstack gap-3 fw-bolder">
                <div>There are no results for that search term</div>
            </div>

            <div className="hstack gap-3">
                <div className="fw-bolder text-nowrap">Suggested searches:</div>

                <div className="hstack gap-3">
                    <Link to={RouteLink.discoverSearch("dialogue")} className="link-white">
                        Dialogue
                    </Link>

                    <Link to={RouteLink.discoverSearch("spooky")} className="link-white">
                        Spooky
                    </Link>

                    <Link to={RouteLink.discoverSearch("poetry")} className="link-white">
                        Poetry
                    </Link>
                </div>
            </div>
        </div>
    ) : (
        <div className="list-group">
            {prompts.map(p => {
                const isActive = activePrompt?.id === p.id;

                return (
                    <button
                        type="button"
                        key={p.id}
                        className={clsx("preset", isActive && "active")}
                        onClick={() => setActivePrompt(p)}
                    >
                        <div
                            className="img-bg flex-shrink-0"
                            style={{
                                width: 100,
                                backgroundImage: `url('${p.imageUrl}')`,
                            }}
                        ></div>

                        <div className="list-group-item d-flex flex-column flex-md-row gap-3 align-items-center flex-grow-1">
                            <div className="vstack gap-1 my-auto">
                                <div className={clsx("h6", !isActive && "text-secondary")}>{p.name}</div>
                                <div>{p.promptText}</div>
                            </div>

                            <div>
                                {p.roundInstructions.length > 0 && (
                                    <span className="text-nowrap">{p.roundInstructions.length} 📖</span>
                                )}
                            </div>

                            <span className="fas fa-chevron-right text-primary d-none d-md-block"></span>
                        </div>
                    </button>
                );
            })}
        </div>
    );
};
